import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';
import { WishList } from 'src/app/utils/functions/wishList';

@Component({
  selector: 'app-make-order-modal',
  templateUrl: './make-order-modal.component.html'
})
export class MakeOrderModalComponent implements OnChanges, OnInit {

  @Input() visible: boolean = false;
  @Output() noVisible = new EventEmitter<boolean>();

  item: IItemWishList = new IItemWishList();
  numItem: number = 0;
  totPriceWishList: number = 0;

  constructor(
    private wishList: WishList
  ) {}

  ngOnInit(): void {
    this.numItem = this.wishList.countForItems();
    this.totPriceWishList = this.wishList.totPriceWishList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.numItem = this.wishList.countForItems();
    this.totPriceWishList = this.wishList.totPriceWishList();
  }


  showDialog() {
    this.visible = true;
  }

  cancelar(){
    this.visible = false;
    this.noVisible.emit(this.visible);
    if(localStorage.getItem('goToOrder')){
      localStorage.removeItem('goToOrder');
    }
  }

}
